<template>
  <div class="order-box">
    <div class="main-top">
      <div class="portrait-box">
        <div class="portrait">
          <img src="../../assets/shop_code.png" alt="">
        </div>
        <p class="user-name">{{userData.CompanyName}}</p>
        <p class="user-info"><span>{{userData.Username}}</span>&nbsp;<span>{{userData.BusinessType | userType}}</span></p>
      </div>
      <div class="wallet-box">
        <div class="wallet">我的钱包</div>
        <div class="money-box">
          <p><span class="txt-bold">{{userData.AwardAmount}}</span><span class="txt999">奖金</span></p>
          <p><span class="txt-bold">{{userData.EnvelopeAmount}}</span><span class="txt999">红包</span></p>
          <p><span class="txt-bold">{{userData.Integral}}</span><span class="txt999">积分</span></p>
          <p><span class="txt-bold">{{userData.CouponCount}}</span><span class="txt999">优惠券</span></p>
        </div>
      </div>
    </div>
    <div class="main-nav">
      <el-tabs class="tabs-box" :stretch="true" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部订单" name="1"> </el-tab-pane>
        <el-tab-pane name="10">
          <span slot="label">待付款{{'('+userData.WaitPayOrderCount+')'}}</span>
        </el-tab-pane>
        <el-tab-pane name="30">
          <span slot="label">待收货{{'('+userData.WaitReceiveOrderCount+')'}}</span>
        </el-tab-pane>
        <el-tab-pane label="已收货" name="40"></el-tab-pane>
        <el-tab-pane label="已完成" name="50"></el-tab-pane>
        <el-tab-pane label="已取消" name="60"></el-tab-pane>
        <el-tab-pane label="已关闭" name="70"></el-tab-pane>
      </el-tabs>
      <div class="table-box">
        <div class="tab-header">
          <span class="tab1">商品信息</span>
          <span class="tab2">单价</span>
          <span class="tab2">数量</span>
          <span class="tab2">实付款</span>
          <span class="tab5">操作</span>
        </div>
        <div class="goods-list">
          <div class="goods-box" v-for="(item, index) in orderList" :key="index">
            <div class="lable"><span>{{item.Status | orderType}}</span><span class="rigth-txt" @click="jumpOrderDetail(item)">订单详情</span></div>
            <div class="goods-item">
              <div class="goods">
                <img class="img" :src="item.SkuList[0].SkuPictureUrl" alt="">
                <div class="txt-box">
                  <span class="txt">{{item.SkuList[0].SkuName}}</span>
                  <span class="buy-num">订单号：{{item.OrderNo}}</span>
                </div>
              </div>
              <span class="tab2">￥{{item.SkuList[0].SkuPrice}}</span>
              <span class="tab2">{{item.SkuList[0].SkuNumber}}</span>
              <span class="tab2">￥{{item.Amount}}</span>
              <span class="tab5">
                <span class="btn btn-border" v-if="item.Status !== 60 && item.Status == 10" @click="paymentFun(item)">立即付款</span>
                <span class="btn btn-border" v-if="item.Status == 20" @click="confirmReceipt(item)">确认收货</span>
                <!-- <span class="btn btn-border" v-if="item.Status == 40" @click="paymentFun(item)">去评价</span> -->
                <span  class="btn" v-if="item.Status !== 60" @click="jumpLogistics(item)">查看物流</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  userInfo,
  UserOrderList,
  UserOrderReceipt
} from '../../api/api'
export default {
  name: 'order',
  filters:{
    userType(val){
      if(val == 0){
        return '经销商'
      } else if(val == 1){
        return '服务商'
      } else if(val == 2){
        return '合伙人'
      } else if(val == 3){
        return '工程师'
      } else if(val == 4){
        return '导购员'
      }
    },
    orderType(val){
      if(val == 10){
        return '待付款'
      } else if(val == 20){
        return '商品正在出库'
      } else if(val == 30){
        return '已发货'
      } else if(val == 40){
        return '已收货'
      } else if(val == 50){
        return '已完成'
      } else if(val == 60){
        return '已取消'
      } else if(val == 70){
        return '已关闭'
      }
    }
  },
  data(){
    return{
      activeName: '1',
      goodsData: [],
      userData: {},
      orderList: [],
    }
  },
  created(){
    this.getUserInfo()
    this.getUserOrderList()
  },
  methods:{
    handleNavClick(v){
      this.activeLi = v.id
    },
    jumpLogistics(val){
      this.$router.push({path: '/personalCenter/logistics', query: {orderNo: val.OrderNo}})
    },
    paymentFun(val){
      this.$router.push({path: '/payment', query: {orderNo: val.OrderNo, money: val.Amount}})
    },
    jumpOrderDetail(val){
      this.$router.push({path: '/personalCenter/orderDetail', query: {orderNo: val.OrderNo}})
    },
    confirmReceipt(val){
      this.$confirm('确认收货吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        let params = {
          orderNo: val.OrderNo
        }
        UserOrderReceipt(params).then(res =>{
          if(res.data.success){
            this.$message.success(res.data.msg)
            this.getUserOrderList()
          } else{
            this.$message.error(res.data.msg)
          }
        })
      }).cath(()=>{})
    },
    getUserInfo(){
      userInfo().then(res => {
        if(res.data.success){
          this.userData = res.data.response || {}
        } else{
          this.$message.error(res.data.msg)
        }
      })
    },
    handleClick(){
      this.getUserOrderList()
    },
    getUserOrderList(){
      let params = {
        type: this.activeName,
        pageIndex: 1,
        pageSize: 10
      }
      if(this.activeName == '1'){
        delete params.type
      }
      UserOrderList(params).then(res =>{
        if(res.data.success){
          this.orderList = res.data.response.data || []
        } else{
          this.$message.error(res.data.msg)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.order-box{

}
.main-top{
  display: flex;
  height: 204px;
  margin-bottom: 20px;
  .portrait-box{
    width: 204px;
    background: linear-gradient(90deg, #F73446 0%, #FB6035 100%);
    border-radius: 10px 0px 0px 10px;
    text-align: center;
    padding: 24px 0;
    .portrait{
      width: 80px;
      height: 80px;
      display: inline-block;
      border-radius: 40px;
      background: #fff;
      overflow: hidden;
      img{
        width: 100%;
        height: 100%;
        border-radius: 40px;
      }
    }
    .user-name{
      font-size: 18px;
      line-height: 28px;
      color: #fff;
      margin: 10px 0;
    }
    .user-info{
      color: #fff;
      font-size: 14px;
      span{
        padding: 3px 5px;
        border-radius: 12px;
        border: 1px solid #ffffff;
      }
    }
  }
  .wallet-box{
    flex: 1;
    width: 736px;
    background: #fff;
    border-radius: 0 10px 10px 0;
    text-align: left;
    .wallet{
      padding-left: 16px;
      border-bottom: 1px solid #f4f4f4;
      height: 50px;
      line-height: 50px;
      font-size: 16px;
      color: #333;
    }
    .money-box{
      // padding-left: 16px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      height: 153px;
      span{
        display: block;
      }
      .txt-bold{
        font-size: 24px;
        color: #474245;
      }
      .txt999{
        color: #999;
      }
    }
  }
}
.main-nav{
  background: #fff;
  border-radius: 10px;
  padding: 20px 0;
  .table-box{
    padding: 0 20px ;
    .tab-header{
      background: #f3f3f3;
      height: 40px;
      line-height: 40px;
      margin-bottom: 20px;
      >span{
        display: inline-block;
      }
    }
    .tab1{
      width: 380px;
      text-align: left;
      padding-left: 20px;
    }
    .tab2{
      width: 100px;
    }
    .tab5{
      width: 200px;
    }
    .goods-list{
      .goods-box{
        border: 1px solid #f3f3f3;
        margin-bottom: 20px;
        .lable{
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 40px;
          background: #f9f9f9;
          color: #f40000;
          line-height: 40px;
          font-size: 12px;
          font-weight: bold;
          text-align: left;
          padding: 0 20px;
          margin-bottom: 20px;
          .rigth-txt{
            cursor: pointer;
            color: #999999;
            font-weight: 500;
          }
          .rigth-txt:hover{
            color: #f40000;
          }
        }
      }
      .goods-item{
        display: flex;
        padding-bottom: 20px;
        padding-left: 20px;
        >span{
          display: inline-block;
        }
        .btn{
          display: block;
          width: 80px;
          margin: 0 auto;
          padding: 3px 5px;
          color: #999;
          cursor: pointer;
        }
        .btn-border{
          border: 1px solid #f40000;
          background: #f40000;
          color: #fff;
          margin-bottom: 10px;
        }
        .goods{
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          width: 380px;
          height: 80px;
          .img{
            width: 80px;
            height: 80px;
          }
          .txt-box{
            width: 300px;
            height: 80px;
            padding-left: 10px;
            position: relative;
            text-align: left;
            .txt{
              text-align: left;
              display: inline-block;
              color: #333333;
            }
            .buy-num{
              position: absolute;
              bottom: 0;
              left: 10px;
              font-size: 12px;
            }
          }
        }
      }
    }
  }
}
.tabs-box /deep/ .el-tabs__nav-scroll {
  padding: 0 20px;
}
.tabs-box /deep/ .el-tabs__item{
  font-size: 20px;
  font-weight: bold;
}
.tabs-box /deep/ .el-tabs__item:hover{
  color: #303133;
}
.tabs-box /deep/ .el-tabs__active-bar{
  background-color: #f40000;
}
.tabs-box /deep/ .is-active{
  color: #f40000;
}
.tabs-box /deep/ .el-submenu /deep/ .el-submenu__title{
  height: 40px;
  line-height: 40px;
}
</style>